// JavaScript for handling the accordion functionality
document.addEventListener('DOMContentLoaded', function() {
    const footerColumns = document.querySelectorAll('.footer-columns .wp-block-column');
    
    footerColumns.forEach(column => {
      // Get all heading-nav pairs within this column
      const headings = column.querySelectorAll('.nav-heading.wp-block-heading');
      
      headings.forEach(heading => {
        // Find the next nav element after this heading
        const nav = heading.nextElementSibling;
        
        if (nav && nav.tagName.toLowerCase() === 'nav' && nav.classList.contains('footer-nav')) {
          heading.addEventListener('click', function() {
            // Check if we're in mobile view
            if (window.innerWidth <= 600) {
              // Toggle active classes
              this.classList.toggle('active');
              nav.classList.toggle('active');
              
              // Accessibility
              const isExpanded = nav.classList.contains('active');
              nav.setAttribute('aria-hidden', !isExpanded);
              heading.setAttribute('aria-expanded', isExpanded);
              
              // Optionally close other open navs in the same column
              const siblingHeadings = column.querySelectorAll('.nav-heading.wp-block-heading');
              siblingHeadings.forEach(siblingHeading => {
                if (siblingHeading !== heading) {
                  siblingHeading.classList.remove('active');
                  siblingHeading.setAttribute('aria-expanded', 'false');
                  
                  const siblingNav = siblingHeading.nextElementSibling;
                  if (siblingNav && siblingNav.tagName.toLowerCase() === 'nav') {
                    siblingNav.classList.remove('active');
                    siblingNav.setAttribute('aria-hidden', 'true');
                  }
                }
              });
            }
          });
          
          // Add ARIA attributes
          heading.setAttribute('role', 'button');
          heading.setAttribute('aria-expanded', 'false');
          nav.setAttribute('aria-hidden', 'true');
          
          // Add tabindex for keyboard navigation
          heading.setAttribute('tabindex', '0');
          
          // Handle keyboard events
          heading.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.click();
            }
          });
        }
      });
    });
    
    // Handle resize events
    let timeout;
    window.addEventListener('resize', function() {
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        const isMobile = window.innerWidth <= 600;
        const navs = document.querySelectorAll('nav.footer-nav');
        const headings = document.querySelectorAll('.nav-heading.wp-block-heading');
        
        navs.forEach(nav => {
          if (!isMobile) {
            nav.classList.remove('active');
            nav.style.display = '';
            nav.setAttribute('aria-hidden', 'false');
          }
        });
        
        headings.forEach(heading => {
          if (!isMobile) {
            heading.classList.remove('active');
            heading.setAttribute('aria-expanded', 'false');
          }
        });
      }, 150);
    });
  });